export const saveLastOpenItem = id => ({
  type: 'SAVE_MENU_ITEM',
  id,
});
